module.exports = __webpack_public_path__ + "img/oto.529ff882.svg";